import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import InternalAccountDetails from "../../../../containers/Accounts/InternalAccount/InternalAccountDetails";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

const InternalAccountDetailsPopup = ({
  internalAccDetailOpen,
  closeBeneAccountDetailModal,
  bene_account_id,
  type,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(disableSwitcher());
    return () => dispatch(enableSwitcher());
  }, [dispatch]);

  return (
    <div>
      <div onClick={(e) => e.stopPropagation()}>
        <LargePopupRedirect
          headerTitle="Internal Account Details"
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headersubtext=""
          headertextSize="font-md"
          isfullViewrequired={true}
          isscrollRequired={true}
          fullviewbtnText="Open in full view"
          fullviewbtnType="button"
          fullviewhandleFunction={() => {
            closeBeneAccountDetailModal();
            navigate(
              `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${bene_account_id}`,
            );
          }}
          fullviewisDisabled={false}
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewdisabledBgColor="var(--text-disabled)"
          fullviewhoverOption="white"
          fullviewicon={ICONS?.REDIRECT}
          closeiconbtnType="button"
          closeiconhandleFunction={closeBeneAccountDetailModal}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
        >
          <InternalAccountDetails
            internalAccDetailOpen={internalAccDetailOpen}
            bene_account_id={bene_account_id}
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            type={type}
            servicesType="BenAdmin"
          />
        </LargePopupRedirect>
      </div>
    </div>
  );
};

export default InternalAccountDetailsPopup;
